<template>
  <div id="VideoDemo">
    <div class="container">
      <br />
      <div class="is-relative">
        <a id="play-video" class="video-play-button" @click="cardModal">
          <span></span>
        </a>
      </div>
      <br />
      <br />
      <br />
    </div>
  </div>
</template>
<script>
import ModalVideo from "@/components/videoDemoModal.vue";
export default {
  name: "VideoDemo",
  props: ["data"],
  data() {
    return {
      title: "VideoDemo",
    };
  },
  methods: {
    cardModal() {
      this.$buefy.modal.open({
        parent: this,
        component: ModalVideo,
        hasModalCard: false,
        trapFocus: true,
        props: {
          url: this.data.video,
        },
      });
    },
  },
};
</script>
